package pwgs.ui

import pwgs.ui.scenes.ensureloggedin.EnsureLoggedInScene
import pwgs.ui.scenes.ensureloggedin.EnsureLoggedInSceneProps
import visage.core.Components
import visage.core.Router
import visage.core.route

fun Components.MainScene() = this.registerFunctionalComponent({}) {
    EnsureLoggedInScene(EnsureLoggedInSceneProps())
}